<template>
  <!-- 充电订单 -->
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="资产码">
        <el-input placeholder="请输入资产码" v-model="filter.assets_code" clearable></el-input>
      </el-form-item>
      <el-form-item label="设备类型">
        <el-select class="selScale" v-model="filter.dev_type">
          <el-option label="--全部--" value=""> </el-option>
          <el-option label="充电桩" value="power_charge_pile"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间" prop="date">
        <el-date-picker v-model="filter.date" type="datetimerange" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <!-- <el-button   icon="el-icon-plus" type="success"
          @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button> -->
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
      <el-table-column label="资产码" prop="assets_code" width="220" align="center"></el-table-column>
      <el-table-column label="设备类型" prop="re_dev_type" width="100" align="center"></el-table-column>
      <el-table-column label="设备名称" prop="re_dev_name" align="center"></el-table-column>
      <el-table-column label="通道" prop="gun_no" width="60" align="center"></el-table-column>
      <el-table-column label="发送编号" prop="model_id" width="90"  align="center"></el-table-column>
      <el-table-column label="返回编号" prop="reply_eleModelId" width="90"  align="center"></el-table-column>
      <el-table-column label="状态" prop="resp_flag" width="110" align="center">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.reply_result == 10">成功</el-tag>
          <el-tag type="danger" v-else>失败/未回</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="create_time" width="160" align="center"></el-table-column>
      <el-table-column label="预发时间" prop="push_time" width="160" align="center"></el-table-column>
      <el-table-column label="实发时间" prop="run_time" width="160" align="center"></el-table-column>
      <el-table-column label="回复时间" prop="reply_time" width="160" align="center"></el-table-column>
      
      <el-table-column :label="$t('publics.operation')" align="center" width="160">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onDetail(row)" v-permision_tjtf="'detail'">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <el-dialog :visible.sync="detailVisible" title="详情" width="1200px" :close-on-click-modal="false">
      <el-row type="flex" justify="center">
        <el-col :span="24">
          <el-form label-position="right" label-width="120px" :model="detailForm" ref="detailForm">
            <el-row :gutter="20">
              <!-- 第一列 -->
              <el-col :span="12">
                <el-form-item label="编号" prop="ID">
                  {{ detailForm.ID }}
                </el-form-item>
                <el-form-item label="资产码" prop="asset_code">
                  <el-input v-model="detailForm.assets_code" readonly disabled />
                </el-form-item>
                <el-form-item label="设备类型" prop="gunNo">
                  <el-input v-model="detailForm.re_dev_type" readonly disabled />
                </el-form-item>
                <el-form-item label="设备名称" prop="gunNo">
                  <el-input v-model="detailForm.re_dev_name" readonly disabled />
                </el-form-item>

                <el-form-item label="通道" prop="gunNo">
                  <el-input v-model="detailForm.gun_no" readonly disabled />
                </el-form-item>
                <el-form-item label="状态" prop="faultSum">
                  <el-tag type="success" v-if="detailForm.reply_result == 10">成功</el-tag>
                  <el-tag type="danger" v-else>失败/未回</el-tag>
                </el-form-item>
              </el-col>

              <!-- 第二列 -->
              <el-col :span="12">
                <el-form-item label="创建时间" prop="modify_time">
                  <el-input v-model="detailForm.create_time" readonly disabled />
                </el-form-item>
                <el-form-item label="预发送时间" prop="timestamp_id">
                  <el-input v-model="detailForm.push_time" readonly disabled />
                </el-form-item>
                <el-form-item label="实发送时间" prop="create_time">
                  <el-input v-model="detailForm.create_time" readonly disabled />
                </el-form-item>

                <el-form-item label="设备回复时间" prop="modify_time">
                  <el-input v-model="detailForm.reply_time" readonly disabled />
                </el-form-item>
                <el-form-item label="发送编号" prop="faultValue_db">
                  <el-input v-model="detailForm.model_id" readonly disabled />
                </el-form-item>
                <el-form-item label="返回编号" prop="faultValue_db">
                  <el-input v-model="detailForm.reply_eleModelId" readonly disabled />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <!-- 第2行 -->
              <el-col :span="24">
                <el-form-item label="发送内容" prop="ID">
                  <pre style="line-height: 20px"> {{ detailForm.charging_config_obj | json }}</pre>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import { GetSendLogPageList } from "@/api/charging_config"
import { mapGetters } from "vuex"
export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: { fileUpload },
  data() {
    return {
      detailForm: {},
      detailVisible: false,
      visible: {
        editGroup: false
      },
      tableData: [],
      filter: {
        assets_code: "",
        dev_type: ""
      },
      loading: false,
      isUpdate: true,
      gid: "" //街道id
    }
  },
  filters: {
    json(value) {
      return JSON.stringify(value, null, 2) // 第二个参数是用于美化输出的空格数
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
    respFlagText() {
      if (this.detailForm.resp_flag === 1) {
        return "已回复"
      } else if (this.detailForm.resp_flag === 0) {
        return "未回复"
      } else {
        return this.detailForm.resp_flag
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    onDetail(row) {
      this.detailForm = { ...row }
      this.detailForm.charging_config_obj = JSON.parse(this.detailForm.charging_config_content)
      this.detailVisible = true
    },
    getData() {
      let startTime = "",
        endTime = ""
      this.loading = true
      if (this.filter.date && this.filter.date.length) {
        startTime = this.filter.date[0]
        endTime = this.filter.date[1]
      }

      this.loading = true
      GetSendLogPageList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        assets_code: this.filter.assets_code || null,
        dev_type: this.filter.dev_type || null,
        start_time: startTime,
        end_time: endTime
      })
        .then((res) => {
          this.tableData = res.data

          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}
</style>
